import { render, staticRenderFns } from "./ConcludedCoursesCertificateList.vue?vue&type=template&id=7fa573c4&scoped=true&"
import script from "./ConcludedCoursesCertificateList.vue?vue&type=script&lang=js&"
export * from "./ConcludedCoursesCertificateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa573c4",
  null
  
)

export default component.exports